import React from 'react'
import { Tooltip } from '@mui/material'
import { GridRow, type GridRowProps } from '@mui/x-data-grid'
import { getTooltipContent } from '../../consts/tooltip'

interface TooltipRowProps extends React.HTMLAttributes<HTMLDivElement>, GridRowProps {
  list: any
  onEditClick?: (row: any) => void
  isRowClickable: boolean
  getRowTooltip?: (rowData: any) => React.ReactNode
}

const TooltipRow: React.FC<TooltipRowProps> = (props) => {
  const { row, list, onEditClick, isRowClickable, getRowTooltip, ...other } = props
  const firstColumn = list?.keys?.[0]?.field || ''
  const isRowMetaDataAvailable = 'taskMetadata' in (props?.row?.data ?? {})
  const rowMetaData = props?.row?.data?.taskMetadata
  const shouldShowMetaDataTooltip = isRowMetaDataAvailable
  let tooltipTitle: React.ReactNode = getTooltipContent({
    rowData: props?.row?.data,
    firstColumn,
    list,
    onEditClick,
    rowMetaData,
    shouldShowMetaDataTooltip
  })
  const shouldShowDefaultEditAction = firstColumn && props?.row?.data && list && onEditClick && !rowMetaData && !shouldShowMetaDataTooltip
  if (shouldShowDefaultEditAction) {
    tooltipTitle = `Double click to open ${String(tooltipTitle ?? '')}`
  }
  let shouldRenderTooltip = shouldShowMetaDataTooltip || isRowClickable
  if (getRowTooltip) {
    tooltipTitle = getRowTooltip(props?.row?.data ?? {})
    shouldRenderTooltip = tooltipTitle != null
  }
  return (
    <Tooltip
      placement="top"
      title={shouldRenderTooltip ? tooltipTitle : ''}
      arrow
      enterDelay={1000}
      enterNextDelay={1000}
      leaveDelay={100}
      disableInteractive
    >
      <div style={{ width: '100%' }}>
        <GridRow row={row} {...other} />
      </div>
    </Tooltip>
  )
}

export default TooltipRow
